import script from "./field-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./field-editor.vue?vue&type=script&setup=true&lang=js"

import "./field-editor.vue?vue&type=style&index=0&id=c6531876&lang=scss"

const __exports__ = script;

export default __exports__